<template>
  <div  class="head-text text-center px-2" 
        :class="{ secondary: isSecondary && !isTranslucent, smll: isSmall && !saveRoom, lg: !isSmall, 'xs': saveRoom, translucent: isTranslucent, 'set-left': left }">
    <span v-if="pillValue|| pillValue === 0">
      <b-badge  pill 
                variant="danger" 
                class="cx-simple-title pillstyle">
        {{ pillValue }}
      </b-badge>
    </span>
    <span v-if="!isSecondary" 
          class="text-center text-bottom text" 
          :class="{ translucent: isTranslucent, 'narrow-075': getNarrow() }">
      {{ getText() }}
    </span>
    <span v-if="kpi && isSecondary" 
          class="text-center text-bottom truncate" 
          :class="{ secondary: isSecondary && !isTranslucent, translucent: isTranslucent, 'narrow-075': getNarrow() }">
      {{ getText() }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    kpi: Object,
    isSecondary: Boolean,
    fallbackText: { type: String, default: './.' },
    pillValue: Number,
    isSmall: { type: Boolean, default: false },
    saveRoom: { type: Boolean, default: false },
    left: { type: Boolean, default: false },
    isTranslucent: Boolean
  },

  methods: {
    getNarrow() {
      return this.getText().length >= 30;
    },
    getText() {
      if (!this.kpi)
        return this.fallbackText;

      if (!this.kpi.Name && !this.kpi.NameShort)
        return this.kpi.GroupCode

      // Sonderlocke für BMW Motorrad, NameShort ist für diese KPIs lang
      if (this.kpi.GroupCode == 'Contractual Standards')
        return this.kpi.Name;
      
      return this.kpi.NameShort || this.kpi.Name;
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "@/../scss/bmw/cx.scss";

.narrow-075 {
  letter-spacing: -0.075em;
}

.truncate {
  // white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.set-left {
  text-align: unset !important;
  padding-left: 0.25rem !important;
}

.text {
  font-size: 1.1em;
  font-weight: bold;
}

.pillstyle {
  font-size: 0.95em !important;
  font-weight: bold;
  height: 1.5rem;
}

.head-text {
  border-radius: 0.25rem;
  padding: 0.25rem 0rem;
  margin: 0.25rem;
}

.text-bottom {
  position: relative;
  bottom: 0px;
}

.lg {
  height: 4rem;
}

.smll {
  height: 3rem!important;
  // margin:  0rem !important;
}
.xs {
  height: 1.5rem!important;
}
.secondary {
  background: cx.$bg-color-solid;
  color: cx.$fg-color;
  line-height: 1.3;
  font-size: 14px;
}

.translucent {
  // line-height: 1.1;
  font-size: 0.9;
  font-size: 15px;
}

</style>